import _ from 'lodash';
import * as treeUtils from '../../components/common/DynamicTree/DynamicTreeUtils';
import * as types from '../../actions/actionTypes';
import initialState from '../initialState';

export default (state = initialState.rldTool, action) => {
  switch (action.type) {
    case types.RLD_TOOL_RESET_GENERATE_FILE: {
      return {
        ...state,
        successMessage: '',
        enableGenerateFile: action.payload,
      };
    }
    case types.RLD_TOOL_SUCCESS_MESSAGE: {
      return {
        ...state,
        successMessage: action.successMessage,
      };
    }
    case types.RLD_TOOL_SET_EMAIL: {
      return {
        ...state,
        email: action.payload,
        successMessage: '',
        enableGenerateFile: action.generateFile,
      };
    }
    case types.RLD_TOOL_SET_DICTIONARY_FILE_STRUCTURE: {
      return {
        ...state,
        successMessage: '',
        dictionaryFileFormat: action.payload,
      };
    }
    case types.RLD_TOOL_SET_EXPORT_FILE_FORMAT: {
      return {
        ...state,
        successMessage: '',
        columnSeperator: action.payload,
      };
    }
    case types.RLD_TOOL_SET_FILE_STRUCTURE_FORMAT: {
      return {
        ...state,
        successMessage: '',
        fileStructureFormat: action.payload,
      };
    }
    case types.RLD_TOOL_SET_ACCOUNTS: {
      return {
        ...state,
        successMessage: '',
        account: {
          accounts: action.Account.data,
          selectedAccount: action.Account.selectedAccount,
        },
        columnSeperator: 1,
        dictionaryFileFormat: 2,
        fileStructureFormat: 1,
        email: [],
        enableGenerateFile: false,
        study: {
          studies: [],
          selectedStudy: {},
          WeightTypes: {},
        },
        dictionary: {
          dictionaryTree: [],
          dictionaryTarget: [],
        },
      };
    }
    case types.RLD_TOOL_SET_SELECTED_ACCOUNT: {
      return {
        ...state,
        successMessage: '',
        study: {
          studies: [],
          selectedStudy: {},
        },
        dictionary: {
          dictionaryTree: [],
          dictionaryTarget: [],
        },
        account: {
          accounts: state.account.accounts,
          selectedAccount: action.data.selectedAccount,
        },
      };
    }
    case types.RLD_TOOL_UPDATE_DICTIONARY_TREE_LOAD: {
      const updatedProps = {};
      if ('active' in action.node) {
        updatedProps.active = action.node.active;
      }
      if ('toggled' in action.node) {
        updatedProps.toggled = action.node.toggled;
      }

      const deepTreeCopy = treeUtils.getDeepTreeCopy(state.dictionaryTree.data);
      let data = '';
      if (action.node.node) {
        data = treeUtils.updateTreeNode(
          deepTreeCopy,
          updatedProps,
          action.node.node
        );
      } else {
        data = treeUtils.updateTreeNode(
          deepTreeCopy,
          updatedProps,
          action.node.recno,
          (node, recno) => node.recno === recno
        );
      }

      if (data) {
        return {
          ...state,
          dictionaryTree: {
            ...state.dictionaryTree,
            data,
          },
        };
      }

      return state;
    }
    case types.RLD_TOOL_GET_DICTIONARY_TREE_LOAD: {
      // to update store for RLD Tool Dictionary tree
      if (action.nodeID !== 0) {
        const deepTreeCopy = treeUtils.getDeepTreeCopy(
          state.dictionary.dictionaryTree
        );

        const data = treeUtils.updateTreeNode(
          deepTreeCopy,
          { children: action.payload.rldDictionaryTree },
          action.nodeID
        );

        return {
          ...state,
          dictionary: {
            ...state.dictionary,
            dictionaryTree: data,
          },
        };
      }
      return {
        ...state,
        dictionary: {
          dictionaryTree: action.payload.rldDictionaryTree,
          dictionaryTarget: [],
        },
      };
    }

    case types.RLD_TOOL_SET_DICTIONARY_TARGET_TREE: {
      // to update store for RLD Tool Target Dictionary tree
      return {
        ...state,
        dictionary: {
          ...state.dictionary,
          dictionaryTarget: action.payload.dictionaryTarget,
        },
      };
    }

    case types.RLD_TOOL_CLEAR_TREE_LOAD_NODE_LIST: {
      return {
        ...state,
        dictionaryTree: {
          status: 200,
          data: [],
        },
      };
    }

    case types.RLD_TOOL_SET_STUDY_DATA: {
      return {
        ...state,
        successMessage: '',
        study: {
          studies: action.payload.studies,
          selectedStudy: action.payload.selectedStudy,
          selectedStudy: {
            ...action.payload.selectedStudy,
            wt: action.payload.selectedStudy.cw[0].wt,
            dv: action.payload.selectedStudy.cw[0].dv,
          },
        },
        dictionary: {
          dictionaryTree: [],
          dictionaryTarget: [],
        },
      };
    }
    case types.RLD_TOOL_SET_SELECTED_STUDY: {
      return {
        ...state,
        successMessage: '',
        study: {
          studies: state.study.studies,
          selectedStudy: action.payload.selectedStudy,
          selectedStudy: {
            ...action.payload.selectedStudy,
            wt: action.payload.selectedStudy.cw[0].wt,
            dv: action.payload.selectedStudy.cw[0].dv,
          },
        },
        dictionary: {
          dictionaryTree: [],
          dictionaryTarget: [],
        },
      };
    }
    case types.UPDATE_RLD_MODULE_STUDY: {
      return {
        ...state,
        study: {
          studies: state.study.studies,
          selectedStudy: { ...action.study },
        },
      };
    }

    case types.RLD_TOOL_SET_IS_DICTIONARY_ONLY: {
      return {
        ...state,
        isDictionaryOnly: action.payload,
      };
    }

    case types.RLD_TOOL_SET_IS_ALL_LOCAL_MARKETS: {
      return {
        ...state,
        isAllLocalMarkets: action.payload,
      };
    }

    case types.RLD_TOOL_SET_CURRENT_VIEW: {
      return {
        ...state,
        currentView: action.payload,
      };
    }
    case types.RLD_TOOL_SET_RLD_LIST_DATA: {
      return {
        ...state,
        rldList: action.payload,
      };
    }
    default:
      return state;
  }
};
